"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapToFormBuilderFields = mapToFormBuilderFields;
exports.mapFormBuilderResultToSchema = mapFormBuilderResultToSchema;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

function mapToFormBuilderFields(schema, content) {
  function isMultiField(properties) {
    return properties.fieldType === "Multi";
  }

  function onFieldMap(hcmsField, field) {
    if (isMultiField(hcmsField.properties)) {
      var _field$value;

      field.value = (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : hcmsField.properties.defaultValue;
    }

    return field;
  }

  function mapDefaults(hcmsField) {
    var _hcmsField$properties, _hcmsField$properties2;

    return {
      name: hcmsField.name,
      label: (_hcmsField$properties = (_hcmsField$properties2 = hcmsField.properties) === null || _hcmsField$properties2 === void 0 ? void 0 : _hcmsField$properties2.label) !== null && _hcmsField$properties !== void 0 ? _hcmsField$properties : undefined,
      // TODO: Remove this @ts-ignore and eslint-disable-next-line after interface fixed
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      properties: hcmsField.properties,
      value: data(hcmsField)
    };
  }

  function data(field) {
    var _path$iv;

    if (!content.data) {
      return null;
    }

    var path = content.data[field.name];

    if (!path) {
      return null;
    }

    var lang = Object.keys(path)[0];
    return (_path$iv = path["iv"]) !== null && _path$iv !== void 0 ? _path$iv : path[lang];
  }

  return schema.fields.map(function (s) {
    var field = mapDefaults(s);
    field = onFieldMap(s, field);
    return field;
  });
}

function mapFormBuilderResultToSchema(_x, _x2, _x3) {
  return _mapFormBuilderResultToSchema.apply(this, arguments);
}

function _mapFormBuilderResultToSchema() {
  _mapFormBuilderResultToSchema = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(config, result, schema) {
    var _languages$items$, _languages$items;

    var service, languages, language, data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            service = new _sdk.AppLanguagesApi(config);
            _context.next = 3;
            return service.getLanguages(config.appName);

          case 3:
            languages = _context.sent;
            language = (_languages$items$ = (_languages$items = languages.items) === null || _languages$items === void 0 ? void 0 : _languages$items[0]) !== null && _languages$items$ !== void 0 ? _languages$items$ : {
              iso2Code: "iv",
              englishName: "Invariant"
            };
            data = {};
            schema.fields.forEach(function (w) {
              var iso = w.partitioning === "language" ? language.iso2Code : "iv";
              data[w.name] = (0, _defineProperty2["default"])({}, iso, result[w.name]);
            });
            return _context.abrupt("return", data);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mapFormBuilderResultToSchema.apply(this, arguments);
}